export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SETTINGS = '/settings';
export const CATEGORIES = '/categories';
export const SUBCATEGORIES = '/subcategories';
export const QUESTIONS = '/questions';
export const USERS = '/users';
export const RATING = '/rating';
export const NOTIFICATION = '/notification';